// Module
var code = "<div data-control-type=\"checkbox-control\" class=\"ToolBarPreview\"> <div data-bind=\"attr{ title: Label }\" class=\"control-preview-container\"> <i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </div> </div>";
// Exports
export default code;